import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FaGoogle } from "react-icons/fa6";
import { Link, useNavigate } from 'react-router-dom';
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../utils/firebase";
import { useDispatch } from 'react-redux';
import { google_login } from '../store/reducers/authReducer';

const Register = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [state, setState] = useState({
    name: '',
    email: '',
    phone: '',
    password: ''
  });

  const inputHandle = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const register = (e) => {
    e.preventDefault();
    navigate('/verify-otp', { state });
  };

  // 🔹 Google Login Function
  const loginWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      // 🔹 Dispatch to backend via Redux
      dispatch(google_login({
        name: user.displayName,
        email: user.email,
        photo: user.photoURL
      })).then((res) => {
        if (res.payload?.token) {
          navigate('/'); // redirect after successful login
        }
      });
    } catch (error) {
      console.error("Google Login Error:", error);
    }
  };


  return (
    <div>
      <Header />
      <div className='bg-slate-200 mt-4'>
        <div className='w-full justify-center items-center p-10'>
          <div className='grid grid-cols-2 sm:grid-cols-1 w-[60%] sm:w-[90%] mx-auto bg-white rounded-md'>
            <div className='px-8 py-8'>
              <h2 className='text-center w-full text-xl text-slate-600 font-bold'>Register</h2>

              <form onSubmit={register} className='text-slate-600'>
                <div className='flex flex-col gap-1 mb-2'>
                  <label htmlFor="name">Name</label>
                  <input
                    onChange={inputHandle}
                    value={state.name}
                    className='w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md'
                    type="text"
                    name="name"
                    id="name"
                    placeholder='Name'
                    required
                  />
                </div>

                <div className='flex flex-col gap-1 mb-2'>
                  <label htmlFor="email">Email</label>
                  <input
                    onChange={inputHandle}
                    value={state.email}
                    className='w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md'
                    type="email"
                    name="email"
                    id="email"
                    placeholder='Email'
                    required
                  />
                </div>

                <div className='flex flex-col gap-1 mb-2'>
                  <label htmlFor="phone">Phone</label>
                  <input
                    onChange={inputHandle}
                    value={state.phone}
                    className='w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md'
                    type="tel"
                    name="phone"
                    id="phone"
                    placeholder='Phone Number'
                    required
                  />
                </div>

                <div className='flex flex-col gap-1 mb-2'>
                  <label htmlFor="password">Password</label>
                  <input
                    onChange={inputHandle}
                    value={state.password}
                    className='w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md'
                    type="password"
                    name="password"
                    id="password"
                    placeholder='Password'
                    required
                  />
                </div>

                <button className='px-8 w-full py-2 bg-[#059473] shadow-lg hover:shadow-green-500/40 text-white rounded-md'>
                  Register
                </button>
              </form>

              <div className='flex justify-center items-center py-2'>
                <div className='h-[1px] bg-slate-300 w-[95%]'></div>
                <span className='px-3 text-slate-600'>Or</span>
                <div className='h-[1px] bg-slate-300 w-[95%]'></div>
              </div>

              {/* 🔹 Google Login Button */}
              <button
                onClick={loginWithGoogle}
                className='px-8 w-full py-2 bg-red-500 text-white rounded-md flex justify-center items-center gap-2 mb-3'>
                <FaGoogle /> Login With Google
              </button>

              <div className='text-center text-slate-600 pt-1'>
                <p>Already have an account? <Link className='text-blue-500' to='/login'>Login</Link></p>
              </div>
            </div>

            <div className='w-full h-full py-4 pr-4'>
              <img src="/images/login.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Register;
